"use strict";
Fotobook.fotoViewer = {
    namespace: '.FotoViewer',
    currentIndex: 0,
    listCount: 7,
    items: [],
    slideshowDelay: 6,
    isSlideshow: false,
    tm: null,
    init(fotos, currentFoto) {
        this.items = fotos.filter((foto) => Boolean(foto.originalExists)).map((foto) => {
            return {
                id: foto.id,
                image: Fotobook.createStorageUrl(foto.preview_path),
                name: foto.original_name,
            };
        });
        this.currentIndex = this.items.findIndex((item) => item.id === currentFoto.id);
        if (this.currentIndex === -1) {
            this.currentIndex = 0;
        }
        this.readEvents();
        this.build();
    },
    initLegacy(event) {
        const $currentItem = $(event.currentTarget).closest('li');
        const currentId = Number($currentItem.find('.image').attr('data-id'));
        this.items = $currentItem.closest('ul').find('li').filter(function () {
            return $(this).find('.image').length && !$(this).find('.no-original').length;
        }).toArray().map((li) => {
            const image = li.querySelector('.image');
            return {
                id: Number(image.getAttribute('data-id')),
                image: image.getAttribute('src'),
                name: li.querySelector('.styled-label').textContent,
            };
        });
        this.currentIndex = this.items.findIndex((item) => item.id === currentId);
        if (this.currentIndex === -1) {
            this.currentIndex = 0;
        }
        this.readEvents();
        this.build();
    },
    build() {
        const html = '<div class="FotoViewer">' +
                        '<div class="FotoViewer-header">' +
                            '<div class="foto-name">Test name</div>' +
                            '<div class="foto-counter">23/45</div>' +
                            '<div class="FotoViewer-close"><strong>X</strong></div>' +
                        '</div>' +
                        '<div class="FotoViewer-content">'+
                            '<div class="FotoViewer-slide"><div class="slider-nav prev"></div><div class="slide-image"></div><div class="slider-nav next"></div></div>' +
                            '<div class="FotoViewer-fotos-list"><div class="list-nav prev"></div><div class="list-inner-wrapper"></div><div class="list-nav next"></div></div>' +
                        '</div>' +
                        '<div class="FotoViewer-footer">' +
                            '<div class="slideshow-run">' +
                                '<input id="slideshow-run-input" type="checkbox" name="slideshow-run-input">' +
                                '<label class="styled-label uniform-sprite-image-ba before" for="slideshow-run-input"><strong>'+t("photobook-js-slideshow")+'</strong></label>' +
                            '</div>' +
                            '<div class="slideshow-delay-slider pages-slider"><div class="slider-name"></div><div class="slideshowdelay-slider" class="slider"><div class="slider-line"></div></div></div>' +
                        '</div>' +
                    '</div><div class="ui-widget-overlay fotoviewer-overlay"></div>';
        $('body').append(html);
        $('.FotoViewer .slideshowdelay-slider').slider({
            min: 1,
            max: 10,
            value: Fotobook.fotoViewer.slideshowDelay,
            step: 1,
            create() {
                $(this).find('.ui-slider-handle').addClass('custom-slider');
                Fotobook.fotoViewer.setSliderName();
            },
            slide(event, ui) {
                Fotobook.fotoViewer.slideshowDelay = ui.value;
                Fotobook.fotoViewer.setSliderName(ui.value);
            },
            stop() {
            },
        });
        this.renderSlide();
        this.renderList();
    },
    setSliderName(value) {
        const sliderName = $('.FotoViewer .slideshow-delay-slider').find('.slider-name');
        value = value || $('.FotoViewer .slideshowdelay-slider').slider('value');
        sliderName.text(`${value} ${t('photobook-js-slidedelay-seconds')}`);
    },
    readEvents() {
        $(document).on('click' + this.namespace, '.FotoViewer-close', Fotobook.fotoViewer.destroy)
                .on('click' + this.namespace, '.list-item-img', function(e){
                    var target = $(e.currentTarget);
                    Fotobook.fotoViewer.renderSlideFromList(target);
                })
                .on('click' + this.namespace, '.slider-nav', function(e){
                    Fotobook.fotoViewer.prevnextSlide($(this).hasClass('prev') ? -1 : 1);
                })
                .on('click' + this.namespace, '.list-nav', function(e){
                    Fotobook.fotoViewer.prevnextList($(this).hasClass('prev') ? -1 : 1);
                })
                .on('change' + this.namespace, '#slideshow-run-input', function(){
                    Fotobook.fotoViewer.isSlideshow = $(this).prop('checked');
                    Fotobook.fotoViewer.runSlideshow();
                }).on("keydown.FotoViewer", function (e) {
                    switch(e.keyCode) {
                        case $.ui.keyCode.ESCAPE:
                            Fotobook.fotoViewer.destroy();
                            break;

                        case $.ui.keyCode.LEFT:
                            Fotobook.fotoViewer.prevnextSlide(-1);
                            break;

                        case $.ui.keyCode.RIGHT:
                            Fotobook.fotoViewer.prevnextSlide(1);
                            break;
                    }
                });
    },
    runSlideshow() {
        if (!this.isSlideshow || this.tm !== null) {
            return;
        }
        this.tm = setTimeout(() => {
            this.prevnextSlide(1);
            this.tm = null;
            this.runSlideshow();
        }, this.slideshowDelay * 1000);
    },
    prevnextSlide(index) {
        let newIndex = this.currentIndex + index;

        if (newIndex > this.items.length - 1) {
            newIndex = 0;
        } else if (newIndex < 0) {
            newIndex = this.items.length - 1;
        }
        this.currentIndex = newIndex;
        this.renderSlide();
    },
    prevnextList(index) {
        this.prevnextSlide(this.listCount * index);
        this.renderList();
    },
    renderSlideFromList($image) {
        this.currentIndex = Number($image.attr('data-index'));
        this.renderSlide();
    },
    renderSlide() {
        const item = this.items[this.currentIndex];
        $('.slide-image').html('<img src="' + item.image + '" alt="slide-image">');
        $('.foto-name').html('<strong>' + item.name.escapeAttr() + '</strong>');
        $('.foto-counter').html('<strong>' + (this.currentIndex + 1) + '</strong>' + '/' + this.items.length);
    },
    _itemTmpl: '<div class="list-item-img" data-index="{index}" data-id="{id}"><img src="{src}" alt="item-list-img"></div>',
    renderList() {
        const needCount = this.listCount;
        const diff = this.items.length - (this.currentIndex + needCount);

        if (diff < 0) {
            this.currentIndex += diff;
        }
        if (this.currentIndex < 0) {
            this.currentIndex = 0;
        }

        const items = [];
        for (let i = this.currentIndex; i < this.items.length && i < this.currentIndex + needCount; i++) {
            items.push(this.items[i]);
        }

        const html = items.map((item, index) => {
            return this._itemTmpl.supplant({
                index,
                id: item.id,
                src: item.image,
            });
        });
        $('.list-inner-wrapper').html(html.join(''));
    },
    destroy() {
        $(document).off(Fotobook.fotoViewer.namespace);
        $('.FotoViewer').remove();
        $('.ui-widget-overlay').remove();
        Fotobook.fotoViewer.currentIndex = 0;
        Fotobook.fotoViewer.isSlideshow = false;
        Fotobook.fotoViewer.tm = null;
    }
};
(function($){
    $(document)
        .on('dblclick', '.images-carousel-wrapper .photocollection-photo-image:not(.folder):not(.back-folder):not(.no-original)', function (e) {
            Fotobook.fotoViewer.initLegacy(e);
        })
        .on('click', '.photocollection-photo-image .fotoviewer-activator', function (e) {
            Fotobook.fotoViewer.initLegacy(e);
    });
})(jQuery);
